<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="10">
            <a-form-item label="项目名称">
              <j-dict-select-tag
                placeholder="请输入项目名称"
                v-model="queryParam.project"
                dictCode="bms_project">
              </j-dict-select-tag>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="期数">
              <a-input placeholder="请录入期数" v-model="queryParam.period"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="10">
            <a-form-item label="开票编码" >
              <a-input v-model="queryParam.invoiceNumber" placeholder="请输入开票编码"></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :md="6" :sm="10">
              <a-form-item label="状态" >
                <!--由于字典中的未推送/已合并 状态不能展示出来，未使用字典绑定j-dict-select-tag-->
                <a-select style="width: 150px;" allowClear v-model="queryParam.status" placeholder="请选择状态">
                  <a-select-option value="1">已推送</a-select-option>
                  <a-select-option value="2">已开票</a-select-option>
                  <a-select-option value="3">已到账</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="10">
              <a-form-item label="经纪人" >
                <j-search-select-tag
                  placeholder="请选择经纪人"
                  v-model="queryParam.broker"
                  dict="sys_user,realname,username,del_flag=0">
                </j-search-select-tag>
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="10">
              <a-form-item label="金额" >
                <a-input v-model="queryParam.money" placeholder="请输入金额"></a-input>
              </a-form-item>
            </a-col>
<!--            <a-col :md="4" :sm="10">
              <a-form-item label="价税合计" >
                <a-input v-model="queryParam.sumPriceTax" placeholder="请输入价税合计"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="开票日期">
                <a-range-picker
                  style="width: 200px"
                  v-model="queryParam.inputDateRange"
                  format="YYYY-MM-DD"
                  :placeholder="['开始日期', '结束日期']"
                  @change="onDateChange"
                />
              </a-form-item>
            </a-col>-->
<!--            <a-col :md="4" :sm="8">
              <a-form-item label="票内/票外">
                <j-dict-select-tag
                  placeholder="请选择"
                  v-model="queryParam.insideOrOutside"
                  dictCode="bms_invoice_in_or_out">
                </j-dict-select-tag>
              </a-form-item>
            </a-col>-->
<!--            <a-col :md="6" :sm="8">
              <a-form-item label="开票单位">
                <j-dict-select-tag
                  placeholder="请选择"
                  v-model="queryParam.invoiceUnit"
                  dictCode="sys_depart,depart_name,org_code">
                </j-dict-select-tag>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="8">
              <a-form-item label="发票开具内容" >
                <j-dict-select-tag type="list" v-model="queryParam.invoiceContent" dictCode="bms_invoice_content" placeholder="请选择发票开具内容"/>
                &lt;!&ndash; <a-input v-model="queryParam.invoiceContent" placeholder="请输入发票开具内容"></a-input> &ndash;&gt;
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="10">
            <a-form-item label="发票号" >
              <a-input v-model="queryParam.invoicePaperCode" placeholder="请输入发票号"></a-input>
            </a-form-item>
          </a-col>-->
          <a-col :md="6" :sm="8">
            <a-form-item label="到账日期">
              <a-range-picker
                style="width: 220px"
                v-model="queryParam.payTime"
                format="YYYY-MM-DD"
                :placeholder="['开始日期', '结束日期']"
                @change="onPayDateChange"
              />
            </a-form-item>
          </a-col>
          </template>

          <a-col :md="4" :sm="10">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator"  style="text-align: right;">
      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'invoiceinfo:add'">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('开票信息表')" v-has="'invoiceinfo:export'">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import" v-has="'invoiceinfo:import'">历史数据导入</a-button>
      </a-upload>
    </div>

    <!-- table区域-begin -->
    <div style="position: relative;">
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        <span style="float:right; ">金额单位：元</span>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">详情</a>
          <a-divider type="vertical"/>
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-if="record.status==1" v-has="'invoiceinfo:invoice'">
                <a @click="handleInvoicing(record)">开票</a>
              </a-menu-item>
              <a-menu-item v-if="record.status==1" v-has="'invoiceinfo:sendBack'">
                <a @click="handleSendBack(record)">退回</a>
              </a-menu-item>
              <a-menu-item v-if="record.status==2" v-has="'invoiceinfo:payed'">
                <a @click="handlePayed(record)">到账</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="printRow(record)" v-has="'invoiceinfo:print'">打印</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
      <div style="position: absolute;left: 0px;bottom: 20px;height:30px;">
        <div style="float:left;">价税合计总额：{{totalPriceTax}}</div>
        <div style="float:left;margin-left: 20px;">保费总额：{{totalRate}}</div>
        <div style="float:left;margin-left: 20px;">金额总额：{{totalMoney}}</div>
        <div style="float:left;margin-left: 20px;">税额总额：{{totalTax}}</div>
      </div>
    </div>

    <biz-invoiceinfo-modal ref="modalForm" @ok="modalFormOk"></biz-invoiceinfo-modal>

    <a-modal v-model="modalVisible2" title="开票" @ok="handleInvoiceDateOk">
        <div style="margin-bottom:20px;">
          <label>开票日期：</label>
          <j-date placeholder="选择开票日期" v-model="invoiceDate" :trigger-change="true" />
        </div>
        <div>
          <label>&nbsp;&nbsp;&nbsp;&nbsp;发票号：</label>
          <a-input type="text" placeholder="请输入发票号" v-model="invoicePaperCode" style="width:180px;" maxLength="100"></a-input>
        </div>
    </a-modal>
    <a-modal v-model="modalVisible" title="选择到账日期" @ok="handlePayDateOk">
      <label>到账日期：</label>
      <j-date placeholder="选择到账日期" v-model="payDate" :trigger-change="true" />
    </a-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { filterObj } from '@/utils/util'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import BizInvoiceinfoModal from './modules/BizInvoiceinfoModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import {getAction,postAction} from '@/api/manage'
  import JSearchSelectTag from "@/components/dict/JSearchSelectTag"
  import JDate from '@/components/jeecg/JDate'

  export default {
    name: 'BizInvoiceinfoList1',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      BizInvoiceinfoModal,
      JSearchSelectTag,
      JDate
    },
    data () {
      return {
        disableMixinCreated: false, // 禁止初始即加载数据
        description: '开票信息表管理页面',
        invoiceDate: '', // 开票日期
        payDate: '', // 到账日期
        invoicePaperCode:'', //发票号
        modalVisible2: false,
        payTime: '', // 到账日期
        modalVisible: false,
        updateId: '',
        totalPriceTax: 0.0, // 价税合计总数
        totalRate: 0.0,
        totalMoney: 0.0,
        totalTax: 0.0, // 税额总数
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'开票编码',
            align:"center",
            dataIndex: 'invoiceNumber',
            sorter: true
          },
          {
            title:'状态',
            align:"center",
            dataIndex: 'status_dictText'
          },
          {
            title:'期数',
            align:"center",
            dataIndex: 'period'
          },
/*          {
            title:'票内/票外',
            // V3
            // title:'票内',
            className:"column-text",
            sorter: true,
            dataIndex: 'insideOrOutside_dictText'
          },*/
          /*{
            title:'开票日期',
            align:"center",
            dataIndex: 'invoiceTime',
            sorter: true
          },*/
          {
            title:'申请人',
            align:"center",
            dataIndex: 'user_dictText'
          },
          {
            title:'到账日期',
            align:"center",
            dataIndex: 'payTime',
            sorter: true
          },
          {
            title:'项目名称',
            className:'column-text',
            dataIndex: 'project_dictText'
          },
          {
            title:'业务类型',
            align:"center",
            dataIndex: 'businessType_dictText'
          },
/*          {
            title:'佣金计算方式',
            align:"center",
            dataIndex: 'brokerageWay_dictText'
          },*/
          {
            title:'经纪人',
            align:"center",
            dataIndex: 'broker_dictText',
            sorter: true
          },
          {
            title:'部门',
            className:'column-text',
            dataIndex: 'insuranceDep_dictText'
          },
          /*{
            title:'发票类型',
            align:"center",
            dataIndex: 'invoiceType_dictText'
          },*/
          {
            title:'购买方名称',
            className:'column-text',
            dataIndex: 'consumerName'
          },
          /*{
            title:'发票开具内容',
            className:'column-text',
            dataIndex: 'invoiceContent_dictText'
          },*/
          {
            title:'保费',
            className:'column-money',
            dataIndex: 'rate',
            customRender:function (text) {
              return !text ? '' : text.toLocaleString()
            }
          },
          {
            title:'金额',
            className:'column-money',
            dataIndex: 'money',
            customRender:function (text) {
              return !text ? '' : text.toLocaleString()
            }
          },
/*          {
            title:'税额',
            className:'column-money',
            dataIndex: 'tax',
            customRender:function (text) {
              return !text ? '' : text.toLocaleString()
            }
          },*/
          {
            title:'价税合计',
            className:'column-money',
            dataIndex: 'sumPriceTax',
            customRender:function (text) {
              return !text ? '' : text.toLocaleString()
            }
          },
          /*{
            title:'开票单位', //九安、 九安分公司
            className:'column-text',
            dataIndex: 'invoiceUnit_dictText',
          },*/
          /*{
            title:'保险公司明细',
            align:"center",
            dataIndex: 'insuranceCompanyInfo'
          },*/
          
          /*{
            title:'发票号',
            align:"left",
            dataIndex: 'invoicePaperCode'
          },*/
          {
            title:'备注',
            className:'column-text',
            dataIndex: 'ps'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:120,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/bms/bizInvoiceinfo/listForFinance?extraParam=1",
          delete: "/bms/bizInvoiceinfo/delete",
          //deleteBatch: "/bms/bizInvoiceinfo/deleteBatch",
          exportXlsUrl: "/bms/bizInvoiceinfo/exportXls",
          importExcelUrl: "bms/bizInvoiceinfo/importExcel",
          invoicing:"/bms/bizInvoiceinfo/invoiced",
          sendBack:'/bms/invoiceOperation/sendBackInvoice',
          payed:'/bms/invoiceOperation/payInvoice', // 到账
        },
        dictOptions:{},
      }
    },
    created() {
    },
    watch:{
      selectionRows: function() {
        let totalPriceTax = 0.0 ,totalRate = 0.0, totalMoney = 0.0, totalTax = 0.0
        for(let i=0; i<this.selectionRows.length; i++){
          totalPriceTax += this.selectionRows[i].sumPriceTax
          totalRate += this.selectionRows[i].rate
          totalMoney += this.selectionRows[i].money
          totalTax += this.selectionRows[i].tax
        }
        this.totalPriceTax = !totalPriceTax ? '0.00' : totalPriceTax.toLocaleString();
        this.totalRate = !totalRate ? '0.00' : totalRate.toLocaleString();
        this.totalMoney = !totalMoney ? '0.00' : totalMoney.toLocaleString();
        this.totalTax = !totalTax ? '0.00' : totalTax.toLocaleString();
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      getQueryParams(){
        //默认的查询条件， 放到高级查询中，以便被getQueryParams()方法调用到
        //财务看到的列表包含已推送/已开票/已到账
        const INVOICE_STATUS_SENT = 1;
        const INVOICE_STATUS_INVOICED = 2;
        const INVOICE_STATUS_PAYED = 3;
        let baseParam={
          status_begin: INVOICE_STATUS_SENT,
          status_end: INVOICE_STATUS_PAYED
        }
        var param = Object.assign(baseParam, this.queryParam, this.isorter ,this.filters);
        if(param.invoiceNumber){
          param.invoiceNumber = `*${param.invoiceNumber}*` // 开票编码模糊匹配
        }
        if(param.invoicePaperCode){
          param.invoicePaperCode = `*${param.invoicePaperCode}*` // 开票编码模糊匹配
        }
        
        let dateRange = param.inputDateRange;
        if(dateRange != null && dateRange != undefined && dateRange.length == 2){
          param.invoiceTime_begin = this.queryParam.inputDateRange[0] + ' 00:00:00';
          param.invoiceTime_end = this.queryParam.inputDateRange[1] + ' 23:59:59';
          delete param.inputDateRange;
        }
        // 到账日期
        if(param.payTime){
          param.payTime_begin = param.payTime[0] + ' 00:00:00'
          param.payTime_end = param.payTime[1] + ' 23:59:59'
          delete param.payTime
        }

        param.field = this.getQueryField();
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        return filterObj(param);
      },

      afterLoadData() {
        this.selectedRowKeys = []
        this.selectionRows = []
      },

      onDateChange: function (value, dateString) {
        this.queryParam.inputDateRange = dateString;
      },
      // 开票
      handleInvoicing(record){
        this.modalVisible2 = true;
        this.updateId = record.id;
      },
      // 开票确认
      handleInvoiceDateOk(){
        
        if(this.updateId == undefined || this.updateId === ''){
          this.$message.warn("请先选择发票")
          return;
        }
        if(this.invoiceDate == undefined || this.invoiceDate === ''){
          this.$message.warn("请选择开票日期")
          return;
        }
        if(this.invoicePaperCode == undefined || this.invoicePaperCode === ''){
          this.$message.warn("请输入发票号")
          return;
        }


        postAction(this.url.invoicing,{id:this.updateId, invoiceDate: this.invoiceDate, invoicePaperCode: this.invoicePaperCode}).then((res)=>{
          if(res.success){
            this.$message.info("开票成功")
            this.invoiceDate = ''
            this.invoicePaperCode = ''
            this.updateId = ''
            this.modalVisible2 = false;
            this.loadData();            
          } else{
            this.$message.warning(res.message)
          }
        })
        
      },

      // 退回
      handleSendBack(record){
        getAction(this.url.sendBack,{id:record.id}).then((res)=>{
          if(res.success){
            this.$message.info("退回成功")
            this.loadData();
          } else{
            this.$message.warning(res.message)
          }
        })
      },
      // 到账 payed
      handlePayed(record){
        this.modalVisible = true;
        this.updateId = record.id;
      },
      // 到账日期确认
      handlePayDateOk(){
        this.modalVisible = false;
        if(this.updateId == undefined || this.updateId === ''){
          this.$message.warn("请先选择发票")
          return;
        }

        postAction(this.url.payed,{id:this.updateId, payTime: this.payDate}).then((res)=>{
          if(res.success){
            this.$message.info("发票到账成功")
            this.payDate = ''
            this.loadData();
          } else{
            this.$message.warning(res.message)
          }
        })
        this.updateId = ''
      },

      print(){
        //批量打印
      },
      printRow(record){
        getAction('/bms/bizInvoiceinfo/getPrintStats', {invoiceId: record.id}).then(res => {
          if (res.success) {
            sessionStorage.setItem("PRINT_INVOICE_STATS", JSON.stringify(res.result));
          } else {
            sessionStorage.removeItem("PRINT_INVOICE_STATS");
          }
        }).catch(() => {
          sessionStorage.removeItem("PRINT_INVOICE_STATS");
        }).finally(() => {
          sessionStorage.setItem("PRINT_INVOICE", JSON.stringify(record));
          let routeUrl = this.$router.resolve({
            path: '/invoice/print',
            name: '总部发票开具申请打印',
            params: {invoice: record}
          });
          window.open(routeUrl.href, '_blank');
        });
      },
      // 到账日期选择
      onPayDateChange: function (value, dateString) {
        this.queryParam.payTime = dateString;
      },
    }
  }
</script>
<style>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
       text-align: center !important;
     }
  td.column-text {
    text-align: left !important;
  }
</style>